import script from "./EditProjectPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProjectPage.vue?vue&type=script&setup=true&lang=ts"

import "./EditProjectPage.vue?vue&type=style&index=0&id=1f8ac53e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8ac53e"]])

export default __exports__